import {getCompletedState} from "../helpers/tools";

const initialState = {
  slide: 'welcome',
  history: [],
  completed: null,
  completedError: null,
  completedSuccess: null,
  summaryCollection: [],
};

export default function reducer(
  state = {
    ...initialState
  },
  action
) {
  switch (action.type) {
    case "GO_TO":
      return {
        ...state,
        history: [...state.history, state.slide],
        slide: action.data,
        completed: null,
      };

    case "GO_BACK": {
      const history = state.history.slice();
      return {
        ...state,
        slide: history.pop(),
        history,
      };
    }

    case "FETCH_LOCATIONS": {
      const completedState = getCompletedState(action.data.locations, action.data.history);
      return {
        ...state,
        ...completedState,
      };
    }

    case "FETCH_SUMMARY":
      return {
        ...state,
        summaryCollection: action.data
      };

    case "TAKE_ACTION_FULFILLED":
      return {
        ...state,
        slide: 'stakeholders',
      };

    case "RESET":
    case "LOGOUT":
      return {
        ...initialState,
      };

    default:
      return state;
  }
}
